import { Injectable } from '@angular/core';
import { Profile } from '@app/models/profile.model';
import { persistState, Store, StoreConfig } from '@datorama/akita';
import * as localForage from 'localforage';

const profileStore = localForage.createInstance({
  name: 'patientLynk',
  storeName: 'profile_store'
});

persistState({ include: ['profile'], storage: profileStore });

@Injectable({ providedIn: 'root' })
@StoreConfig({
  name: 'profile',
  resettable: true,
  cache: {
    ttl: 600000 // 10m
  }
})
export class ProfileStore extends Store<Profile> {

  constructor() {
    super({});
  }

  akitaPreUpdate(prevState: Readonly<Profile>, nextState: Readonly<Profile>): Profile {
    this.setHasCache(true);
    return super.akitaPreUpdate(prevState, nextState);
  }
}
